/** The script directory to submit: the user's explicit edit, or the
 *  per-service default derived from the service name. Bare "./scripts"
 *  services share one root and don't provision their scripts (TTTL-139) —
 *  every creation path (SaveServiceModal, the engine's agent tools, here)
 *  uses ./scripts/{name}. */
export function udfScriptPath(
  custom: string | null,
  serviceName: string,
): string {
  if (custom !== null) return custom;
  return serviceName === "" ? "./scripts" : `./scripts/${serviceName}`;
}
